<template>
  <template v-if="loading">
    <AppSpinner
      v-if="loading"
      class="page-spinner"
    />
  </template>

  <template v-else>
    <AppTable
      :loading="loading"
      :if-looped-items-exist="event.prices?.length > 0"
      class="price-table max-w-7xl w-full mx-auto"
    >
      <template #headings>
        <th>Style</th>
        <th>Delivery</th>
        <th>Size</th>
        <th>Type</th>
        <th>Price</th>
        <th class="sr-only" />
      </template>

      <template #rows>
        <tr
          v-for="price in event.prices"
          :key="price.id"
        >
          <td>
            {{ price.style }}
          </td>

          <td>
            {{ price.delivery || '-' }}
          </td>

          <td>
            {{ price.size || '-' }}
          </td>

          <td>
            {{ price.type || '-' }}
          </td>

          <td>
            R{{ price.price.toFixed(2) || '-' }}
          </td>

          <td>
            <div class="w-fit ml-auto">
              <AppButton
                class="py-1 px-3 text-gray-dark font-medium"
                @click="priceToEdit = price"
              >
                Edit
              </AppButton>
            </div>
          </td>
        </tr>
      </template>
    </AppTable>

    <!-- Edit Price -->
    <Transition name="fade">
      <AppModal
        v-if="priceToEdit"
        :disabled="isSubmitting"
        class="event-overview-edit-modal"
        @close="handleModalClose"
      >
        <PriceForm
          :price="priceToEdit"
          :errors="errors"
          :processing="isSubmitting"
          @confirm="handleEditPrice"
          @close="handleModalClose"
        />
      </AppModal>
    </Transition>
  </template>
</template>

<script setup>
import { HttpStatusCode } from 'axios';

import {
  inject,
  ref,
  watch,
} from 'vue';

import { useRoute } from 'vue-router';

import {
  AppContainer,
  AppButton,
  AppSpinner,
  AppModal,
} from '@/components/app';

import { PriceForm } from '@/components/forms/admin';
import { AppTable } from '@/components/app';

import { useHttp, useFormSubmit } from '@/composables';

const { isSubmitting, errors } = useFormSubmit();

const route = useRoute();

const priceToEdit = ref(null);

const injectedEvent = inject('event');
const event = ref({});

const loading = inject('event.loading');

const handleEditPrice = async (price) => {
  errors.value = null;
  isSubmitting.value = true;

  const response = await useHttp().put(`events/${route.params.slug}/prices/${priceToEdit.value.id}`, price);

  if (response.statusCode === HttpStatusCode.Ok) {
    event.value.prices = event.value.prices.map(price => {
      if (price.id === priceToEdit.value.id) {
        return response.data;
      }

      return price;
    });

    priceToEdit.value = null;
  } else if (response.statusCode === HttpStatusCode.UnprocessableEntity) {
    errors.value = response.errors;
  }

  isSubmitting.value = false;
};

const handleModalClose = () => {
  priceToEdit.value = null;
  errors.value = null;
};

watch(injectedEvent, value => {
  if (value) {
    event.value = value;
  }
}, { deep: true, immediate: true });

</script>
